import { useTranslation } from 'react-i18next';

// Components
import SectionTitle from '../../SectionTitle';

// Styles
import styles from './index.module.sass';

export default function CatalogsUS({ device }) {
  const { screenSize } = device;

  const { t } = useTranslation('catalogsmx');

  const catalogs = t('catalogs', { returnObjects: true });

  function openWindow(url) {
    window.open(url, '_blank');
  }

  return (
    <div className={`${styles.Catalogs} ${styles[screenSize]}`}>
      <SectionTitle title={t('title')} subtitle={t('subtitle')} />
      <div className={styles.container}>
        {catalogs.map((val, key) => {
          const { image = '', title = '', url = '' } = val;

          return (
            <div key={key} className={styles.catalogContainer}>
              <div className={styles.catalogContent}>
                <div className={styles.imageContainer}>
                  <img src={image} alt={title} className={styles.image} />
                </div>
                <div className={styles.documentTitle}>{title}</div>
                <div className={styles.buttonContainer}>
                  <div className={styles.button} onClick={() => openWindow(url)}>
                    <i class='material-icons-outlined'>file_download</i>
                    {t('buttonText')}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
